"use client";

import Button from '@/components/button';
import styles from './_video.module.scss';
import { useRef, useState } from 'react';
import Video from '@/components/video';
import getOptimizedImageUrl from '@/util/getOptimizedImageUrl';

export default function HcpCahOverviewVideo() {
  const videoRef = useRef(null);
  const [showTranscript, setShowTranscript] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const transcript = <>
    <p><strong>Length: 02:59</strong></p>
    <p><strong>RUN YU, MD/PHD:</strong> If the patient is on a higher supraphysiologic dose of glucocorticoid, 
    or has unsuppressed adrenal androgens, then CRENESSITY clearly has a role.</p>
    <p><strong>RUN YU, MD/PHD:</strong> So before the advent of CRENESSITY, I felt like, I&rsquo;m treating a disease with two aspects, but with only one tool, kind of like you drive a car that can only turn right, so you can turn right three times to turn left.</p>
    <p>So now, with CRENESSITY, I basically have a car that can turn both ways, and I can specifically target my patient&rsquo;s specific needs….For one patient, I have been able to reduce the glucocorticoid dose while maintaining his adrenal androgen level.</p>
    <p>When I tell my patients about starting CRENESSITY, I let them know that the most common side effects adult patients experienced in the clinical trial were fatigue, headache, dizziness, arthralgia, also called….joint pain, back pain, decreased appetite, and myalgia, also called muscle pain.</p>
    <p><strong>AMRIT BHANGOO, MD:</strong>  I have been able to decrease glucocorticoid after starting CRENESSITY on a child who&rsquo;s now eight years of age, who over the last one year has been gaining weight, because I think around the seven or eight years, the adrenal androgens ramp up, so I was increasing his glucocorticoid dose.</p>
    <p>But there is also another 15-year-old….and we&rsquo;re having to do a little bit longer CRENESSITY dosing before we can lower the hydrocortisone dose….but overall, her androgen levels are also coming down. That&rsquo;s good news, androgen levels are coming down. I&rsquo;m just giving a little bit more time on just CRENESSITY and the same hydrocortisone dose before we step down.</p>
    <p>When I tell my patients about starting CRENESSITY, I let them know that the most common side effects pediatric patients experienced in the clinical trial were headache, abdominal pain, or stomach pain, fatigue, nasal congestion, and epistaxis, or nosebleeds.</p>
    <p><strong>HEIDI SHEA, MD:</strong> With CRENESSITY, in one of my patients, a young girl, she&rsquo;s in her 20s, ….but she came back, and it was interesting because she said, &ldquo;I just don&rsquo;t feel as hungry anymore.&rdquo;</p>
    <p><strong>AMRIT BHANGOO, MD:</strong>  Yeah, the 15-year-old that I just talked about, she also reported exactly the same thing. She&rsquo;s feeling less -- hungry, she lost weight, and that&rsquo;s directly because of the androgen levels coming down.</p>
    <p><strong>HEIDI SHEA, MD:</strong>  Was it before you adjusted the GC dose?</p>
    <p><strong>AMRIT BHANGOO, MD:</strong>  This is before the adjustment of the GC dose, yeah.</p>
    <p><strong>RUN YU, MD/PHD:</strong> For my patient, he also lost weight and he also now takes less frequently the hydrocortisone, and now he kind of asked us, &ldquo;Why I took a higher dose before?&rdquo; And I said, &ldquo;Well, that&rsquo;s because we did not have CRENESSITY at that time.&rdquo;</p>
  </>;

  function handleReadTranscript() {
    setShowTranscript(!showTranscript);
  }

  return (
    <>
      <section className={styles.container}>
        <div className="container">

          <div className={styles.wrapper}>
            <div className={styles.content}>
              
                <div className={styles.content_video}>
                  <div className="tablet:hidden">
                    <Video
                      ref={videoRef}
                      url="https://player.vimeo.com/progressive_redirect/playback/1132559463/rendition/1080p/file.mp4?loc=external&signature=9bcaed083ef0a1c7fb7138bd0926978d086ee9667f1507c330ea7f9befe8248f"
                      title="KOL Video"
                      poster={getOptimizedImageUrl("/images/posters/hcp/video-who-may-benefit.jpg", 1332)}
                      gtmEventCategory="Video"
                      gtmEventAction="Play/Pause"
                      gtmEventLabel="Who May Benefit From Crenessity Video Play/Pause Video"
                      id="benefit-video_mobile"
                      autoplay={true}
                      onVideoPause={() => setVideoPlaying(false)}
                      onVideoPlay={() => setVideoPlaying(true)}
                      describedBy="benefit-video_mobile_note"
                      caption="/images/page/hcp/videos/captions/CRENESSITY_WHO-MAY-BENEFIT.vtt"
                    />
                    <div id="benefit-video_mobile_note" className={`tablet:hidden ${styles.content_video_note}`}>These physicians have been compensated by Neurocrine for sharing their views.</div>
                  </div>
                  {!showTranscript &&
                  <div className={styles.content_video_header}>
                    <h2>Who May Benefit From CRENESSITY</h2>
                    <p>CAH specialists discuss the range of patients they consider appropriate for treatment with CRENESSITY.</p>
                    
                  </div>
                  }
                  {!showTranscript &&
                  <div className={styles.button_container}>
                    <div className={styles.button_wrapper}>
                      <Button
                        type="button"
                        variant="outline--eggplant"
                        onClick={handleReadTranscript}
                        data-gtm-event-category="Action"
                        data-gtm-event-action="Click"
                        data-gtm-event-label="Read video transcript - Who May Benefit From Crenessity"
                      >Read video transcript</Button>
                    </div>
                  </div>
                  }
                </div>
             
              {showTranscript &&
                <div className={styles.content_transcript}>
                  <div className={styles.transcript}>{transcript}</div>
                  <div className={styles.button_wrapper}>
                    <Button
                      type="button"
                      variant="outline--eggplant"
                      onClick={handleReadTranscript}
                      data-gtm-event-category="Action"
                      data-gtm-event-action="Click"
                      data-gtm-event-label="Close video transcript - Who May Benefit From Crenessity"
                    >Close video transcript</Button>
                  </div>
                </div>
              }

            </div>
            <div className="hidden tablet:block">
              <Video
                ref={videoRef}
                url="https://player.vimeo.com/progressive_redirect/playback/1132559463/rendition/1080p/file.mp4?loc=external&signature=9bcaed083ef0a1c7fb7138bd0926978d086ee9667f1507c330ea7f9befe8248f"
                title="KOL Video"
                poster={getOptimizedImageUrl("/images/posters/hcp/video-who-may-benefit.jpg", 1332)}
                gtmEventCategory="Video"
                gtmEventAction="Play/Pause"
                gtmEventLabel="Who May Benefit From Crenessity Video Play/Pause Video"
                id="benefit-video_desktop"
                autoplay={true}
                onVideoPause={() => setVideoPlaying(false)}
                onVideoPlay={() => setVideoPlaying(true)}
                describedBy="benefit-video_desktop_note"
              />
              <div id="benefit-video_desktop_note" className={styles.content_video_note}>These physicians have been compensated by Neurocrine for sharing their views.</div>
            </div>
            
          </div>
        </div>
        <hr className={styles.divider} />
      </section>
    </>
  );
}
